module.exports = __webpack_public_path__ + "static/CoffeeBean_pin-f6dc78c85b09f84baca1811f3334e409.png";